export const loginEvent = 'login'
